/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { FormDialog } from "components/common_components/Dialogs";
import { Form as FormikForm, TextField, SelectField, AutocompleteField, CheckboxField } from "components/common_components/Formik";
import { Grid } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import { updateTaskValidationSchema } from "./validationSchemas";
import { taskStatuses } from "utils/static/workflowsStaticData";
import AppContext from "AppContext";
import { useDispatch, useSelector } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";
import { ConfirmDialog } from "components/common_components/Dialogs";
import { CircularProgress } from "components/common_components/Progress";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import SendIcon from "@material-ui/icons/Send";
import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Comment from "./Comment";
import { dateTimeAdd, dateToString, getUnitsOfTime } from "utils/dateUtils";
import { hasElements } from "utils/arrays";

const useStyles = makeStyles((theme) => ({
    commentsPanel: {
        borderLeft: "gainsboro 1px solid",
        backgroundColor: "#f5f5f557",
        "& legend, label": {
            backgroundColor: "transparent",
        },
    },
    commentsContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxHeight: 340,
        minHeight: 340,
        overflowY: "auto",
        padding: 10,
    },
    loaderContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200,
        width: "100%",
    },
    addCommentContainer: {
        border: "gainsboro 1px solid",
        backgroundColor: "white",
        padding: "20px !important",

        "& label": {
            marginTop: "10px !important",
            marginLeft: "12px !important",
        },
    },
    searchContainer: {
        padding: "20px 0",
    },
    autocompleteOption: {
        display: "flex",
        flexDirection: "column",
        padding: 5,
        width: "100%",
    },
    autocompleteOptionUserName: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },
    adminFlag: {
        fontSize: "smaller",
        color: "silver",
    },
    notificationDisclaimerSuccess: {
        padding: 8,
        border: "green 1px solid",
        display: "flex",
        flexDirection: "column",
        gap: 5,
        borderRadius: 5,
        backgroundColor: "#eaf7eb",
        "& small": {
            color: () => "green",
        },
    },
    notificationDisclaimerPending: {
        padding: 8,
        border: "#3f51b5 1px solid",
        display: "flex",
        flexDirection: "column",
        gap: 5,
        borderRadius: 5,
        backgroundColor: "#eaecf7",
        "& small": {
            color: () => "#3f51b5",
        },
    },
}));

export default function EditTaskDialog({ task, resources, onSuccessCallback, ...formDialogProps }) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [initialValues, setInitialValues] = useState(undefined);
    const [commentsResponse, setCommentsResponse] = useState([]);
    const [comments, setComments] = useState([]);
    const [isLoadingComments, setIsLoadingComments] = useState(false);
    const [activity, setActivity] = useState([]);
    const [isLoadingActivity, setIsLoadingActivity] = useState(false);
    const [commentToSave, setCommentToSave] = useState("");
    const [commentToSearch, setCommentToSearch] = useState("");
    const [commentToEdit, setCommentToEdit] = useState(undefined);
    const [commentInputMode, setCommentInputMode] = useState("add");
    const { user } = useSelector((state) => state.Login);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [statusChangeDisclaimerDialogProps, setStatusChangeDisclaimerDialogProps] = useState({
        open: false,
        title: "Close task",
        content:
            "You are about to close this task. If you do it, you're confirming that every action indicated in the task was carried out successfully. \n \n Do you want to proceed?",
        onSecondaryClick: () => {},
        onPrimaryClick: () => {},
        onClose: () => {
            setStatusChangeDisclaimerDialogProps((prev) => ({
                ...prev,
                open: false,
            }));
        },
    });

    const {
        api: {
            Workflows: { Tasks, Comments, Activity },
        },
    } = useContext(AppContext);

    async function getComments() {
        try {
            if (task) {
                setIsLoadingComments(true);
                const commentsResponse = await Comments.getAllByTaskAsync({ trnFlowTaskId: task.id });
                if (commentsResponse && Array.isArray(commentsResponse)) {
                    setCommentsResponse(commentsResponse);
                    setComments(commentsResponse);
                } else {
                    dispatch(notifyError("The Comments' response has an invalid format!"));
                }
            } else {
                dispatch(notifyError("No task information to fetch its comments!"));
            }
        } catch (error) {
            dispatch(notifyError(`Error gettings the comments!. \n ${error}`));
        } finally {
            setIsLoadingComments(false);
        }
    }

    async function getActivity() {
        try {
            if (task) {
                setIsLoadingActivity(true);
                const activityResponse = await Activity.getAllByTaskAsync({ trnFlowTaskId: task.id });
                if (activityResponse && Array.isArray(activityResponse)) {
                    setActivity(activityResponse);
                } else {
                    dispatch(notifyError("The Activity's response has an invalid format!"));
                }
            } else {
                dispatch(notifyError("No task information to fetch its activity!"));
            }
        } catch (error) {
            dispatch(notifyError(`Error gettings the activity!. \n ${error}`));
        } finally {
            setIsLoadingActivity(false);
        }
    }

    useEffect(() => {
        const cleanUp = () => {
            setCommentsResponse([]);
            setComments([]);
            setActivity([]);
            setCommentToSave("");
            setCommentToSearch("");
            setCommentToEdit(undefined);
        };

        if (formDialogProps.open) {
            getComments();
            getActivity();
        } else {
            cleanUp();
        }

        return cleanUp;
    }, [formDialogProps.open]);

    function getInitialValues() {
        const result = {
            name: task.name,
            description: task.description,
            status: task.status,
            assigneeUser: getUsersOptions().find((x) => x.id === task.assigneeUserId),
            startDateString: task.startDateString,
            endDateString: task.endDateString,
            dueDateString: task.dueDateString,
            dueDate: task.dueDate,
            notifyBeforeDueDate: (Boolean(task.dueDateNotificationDatetime) ? null : task.notifyBeforeDueDate) || false,
            notifyBeforeDueDateInterval: 0,
            notifyBeforeDueDateTimeUnit: "",
            notifyBeforeDueDateUsers: task.dueDateNotificationConfig
                ? JSON.parse(task.dueDateNotificationConfig).mailsTo.map(getUserByEmail)
                : [],
            dueDateNotificationDatetime: task.dueDateNotificationDatetime,
            dueDateNotificationProcessed: task.dueDateNotificationProcessed,
            dueDateNotificationProcessedDatetime: task.dueDateNotificationProcessedDatetime,
        };
        return result;
    }

    useEffect(() => {
        const cleanUp = () => {
            setInitialValues(undefined);
        };
        if (task && hasElements(resources.users)) {
            setInitialValues(getInitialValues());
        } else {
            cleanUp();
        }

        return cleanUp;
    }, [task, resources.users]);

    function onSuccess(sentPayload, setSubmitting) {
        setSubmitting(false);
        setIsSubmitting(false);
        dispatch(notifySuccess(`Task updated successfully!`));
        formDialogProps.onClose();
        onSuccessCallback();
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            dispatch(notifyError(error));
            formDialogProps.onClose();
        }
        setSubmitting(false);
        setIsSubmitting(false);
    }

    function normalizeUsersToNotify(notifyBeforeDueDateUsers, assigneeUser) {
        const mailsTo = [];
        if (hasElements(notifyBeforeDueDateUsers)) {
            const filteredUsers = assigneeUser
                ? notifyBeforeDueDateUsers.filter((x) => x.id !== assigneeUser.id)
                : notifyBeforeDueDateUsers;
            mailsTo.push(...filteredUsers.map((x) => x.email));
        }
        return mailsTo;
    }

    const isMyTask = user && user.id && task && task.assigneeUserId === user.id;
    const allowReassign = (user && user.isAdmin) || (isMyTask && task.allowAssigneeReassign);

    function doSubmit(values, { setSubmitting, setErrors }) {
        const {
            assigneeUser,
            dueDate,
            notifyBeforeDueDate,
            notifyBeforeDueDateInterval,
            notifyBeforeDueDateTimeUnit,
            notifyBeforeDueDateUsers,
            changeNotifyBeforeDueDateValues,
        } = values;
        const assigneeUserId = allowReassign && assigneeUser ? assigneeUser.id : task.assigneeUserId;

        let dueDateNotificationDatetime = null;
        let dueDateNotificationConfig = null;

        if (dueDate && (notifyBeforeDueDate || changeNotifyBeforeDueDateValues)) {
            dueDateNotificationDatetime = dateTimeAdd(
                dueDate,
                Number(notifyBeforeDueDateInterval) * -1,
                String(notifyBeforeDueDateTimeUnit)
            );
            dueDateNotificationConfig = JSON.stringify({
                mailsTo: normalizeUsersToNotify(notifyBeforeDueDateUsers, assigneeUser),
            });
        }

        const payloadToSend = {
            id: task.id,
            status: values.status,
            assigneeUserId,
            notifyBeforeDueDate: notifyBeforeDueDate || changeNotifyBeforeDueDateValues ? true : null,
            dueDateNotificationDatetime,
            dueDateNotificationConfig,
        };

        setSubmitting(true);
        setIsSubmitting(true);

        Tasks.update({
            payload: payloadToSend,
            onSuccess: () => onSuccess(payloadToSend, setSubmitting),
            onError: (error) => onError(error, setSubmitting, setErrors),
        });
    }

    function onSubmitHandler(values, form) {
        if (values.status === "closed") {
            setStatusChangeDisclaimerDialogProps((prev) => ({
                ...prev,
                open: true,
                onSecondaryClick: () => {
                    form.setSubmitting(false);
                    setStatusChangeDisclaimerDialogProps((prev) => ({ ...prev, open: false }));
                },
                onPrimaryClick: () => doSubmit(values, form),
            }));
        } else {
            doSubmit(values, form);
        }
    }

    function getUsersOptions() {
        return [{ id: null, name: "Unassigned" }, ...resources.users];
    }

    function getUserByEmail(email) {
        return resources.users.find((x) => x.email === email);
    }

    async function saveComment() {
        if (commentToSave && String(commentToSave).trim().length > 0) {
            try {
                const apiCall = commentInputMode === "add" ? Comments.addForTaskAsync : Comments.updateForTaskAsync;
                const responseSaveComment = await apiCall({
                    trnFlowTaskId: task.id,
                    payload: {
                        id: commentInputMode === "add" ? null : commentToEdit.id,
                        comment: commentToSave,
                        userId: user.id,
                    },
                });
                if (responseSaveComment) {
                    dispatch(notifySuccess("Comment saved successfully!"));
                    getComments();
                    setCommentToSave("");
                    setCommentToEdit(undefined);
                    setCommentInputMode("add");
                }
            } catch (error) {
                dispatch(notifyError(`Error saving comment!. \n ${error}`));
            }
        }
    }

    async function onSearchInputChange(event) {
        setCommentToSearch(event.target.value);
        searchComment(event.target.value);
    }

    async function searchComment(value) {
        const txtToSearch = value || commentToSearch;
        if (txtToSearch && String(txtToSearch).trim().length > 0) {
            const filteredComments = commentsResponse.filter((c) => String(c.comment).toLowerCase().includes(txtToSearch.toLowerCase()));
            setComments(filteredComments);
        } else {
            setComments(commentsResponse);
        }
    }

    async function onSearchInputKeyDown(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            searchComment();
        }
    }

    async function onEditCommentHandler(comment) {
        setCommentToEdit(comment);
        setCommentToSave(comment.comment);
        setCommentInputMode("edit");
    }

    async function onDeleteCommentHandler(comment) {
        if (comment && comment.id) {
            try {
                await Comments.deleteForTaskAsync({ trnFlowTaskId: task.id, id: comment.id });
                dispatch(notifySuccess("Comment deleted successfully!"));
                getComments();
            } catch (error) {
                dispatch(notifyError(`Error deleting comment!. \n ${error}`));
            }
        }
    }

    async function cancelEditComment() {
        setCommentToEdit(undefined);
        setCommentInputMode("add");
    }

    return (
        <>
            <FormDialog {...formDialogProps} isSubmitting={isSubmitting}>
                {initialValues && (
                    <FormikForm
                        id={formDialogProps.formId}
                        onSubmit={onSubmitHandler}
                        validateOnChange={false}
                        initialValues={initialValues}
                        validationSchema={updateTaskValidationSchema}
                        showButtons={false}
                    >
                        {({ values }) => (
                            <Grid container spacing={3}>
                                <Grid item sm={12} md={4}>
                                    <FormControl component="fieldset" fullWidth>
                                        <FormLabel component="legend">Task #{task?.id} - General information</FormLabel>
                                        <FormGroup row>
                                            <TextField disabled fieldName="name" label="Name" multiline minRows={3} />
                                            <TextField disabled fieldName="description" label="Description" multiline minRows={10} />
                                            <AutocompleteField
                                                disabled={!allowReassign}
                                                fieldName="assigneeUser"
                                                label="Assignee User"
                                                options={getUsersOptions()}
                                                valueKey="id"
                                                labelKey="name"
                                                renderOption={(option) => (
                                                    <div className={classes.autocompleteOption}>
                                                        <div className={classes.autocompleteOptionUserName}>
                                                            <div>
                                                                <strong>{option.name}</strong>
                                                            </div>
                                                            <small className={classes.adminFlag}>{option.isAdmin ? "admin" : ""}</small>
                                                        </div>
                                                        <small>{option.email}</small>
                                                    </div>
                                                )}
                                                getOptionLabel={(option) => (option ? option.name : "")}
                                            />
                                            <SelectField fieldName="status" label="Status *" options={taskStatuses} margin="normal" />
                                        </FormGroup>
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={3}>
                                    <FormControl component="fieldset" fullWidth>
                                        <FormLabel component="legend">Times</FormLabel>
                                        <FormGroup row>
                                            <TextField disabled fieldName="startDateString" label="Start Date" />
                                            <TextField disabled fieldName="endDateString" label="End Date" />
                                            <TextField disabled fieldName="dueDateString" label="Due Date" />
                                        </FormGroup>
                                    </FormControl>
                                    {values.dueDate && (
                                        <FormControl component="fieldset" fullWidth>
                                            <FormLabel component="legend">Notifications</FormLabel>
                                            {values.dueDateNotificationProcessed ? (
                                                <div className={classes.notificationDisclaimerSuccess}>
                                                    <small className={classes.adminFlag}>
                                                        Sent on {dateToString(values.dueDateNotificationProcessedDatetime)} to:
                                                    </small>
                                                    <ul>
                                                        {hasElements(values.notifyBeforeDueDateUsers) &&
                                                            values.notifyBeforeDueDateUsers.map((x) => {
                                                                return (
                                                                    <li>
                                                                        <small className={classes.adminFlag}>- {x.name}</small>
                                                                    </li>
                                                                );
                                                            })}
                                                    </ul>
                                                </div>
                                            ) : (
                                                <FormGroup row>
                                                    {values.dueDateNotificationDatetime ? (
                                                        <>
                                                            <div className={classes.notificationDisclaimerPending}>
                                                                <small className={classes.adminFlag}>
                                                                    A notification will be sent on{" "}
                                                                    {dateToString(values.dueDateNotificationDatetime)} to:
                                                                </small>
                                                                <ul>
                                                                    {hasElements(values.notifyBeforeDueDateUsers) &&
                                                                        values.notifyBeforeDueDateUsers.map((x) => {
                                                                            return (
                                                                                <li>
                                                                                    <small className={classes.adminFlag}>- {x.name}</small>
                                                                                </li>
                                                                            );
                                                                        })}
                                                                </ul>
                                                            </div>
                                                            {!task?.trnFlowId && (
                                                                <CheckboxField
                                                                    fieldName="changeNotifyBeforeDueDateValues"
                                                                    label="Change notification"
                                                                />
                                                            )}
                                                        </>
                                                    ) : (
                                                        <CheckboxField fieldName="notifyBeforeDueDate" label="Notify due date" />
                                                    )}
                                                    {(values.notifyBeforeDueDate || values.changeNotifyBeforeDueDateValues) && (
                                                        <>
                                                            <TextField
                                                                disabled={
                                                                    !(
                                                                        Boolean(values.notifyBeforeDueDate) ||
                                                                        Boolean(values.changeNotifyBeforeDueDateValues)
                                                                    )
                                                                }
                                                                fieldName="notifyBeforeDueDateInterval"
                                                                label="Interval *"
                                                                type="number"
                                                            />
                                                            <SelectField
                                                                disabled={
                                                                    !(
                                                                        Boolean(values.notifyBeforeDueDate) ||
                                                                        Boolean(values.changeNotifyBeforeDueDateValues)
                                                                    )
                                                                }
                                                                fieldName="notifyBeforeDueDateTimeUnit"
                                                                label="Unit of time *"
                                                                options={getUnitsOfTime(true)}
                                                            />
                                                            <AutocompleteField
                                                                fieldName="notifyBeforeDueDateUsers"
                                                                disabled={
                                                                    !(
                                                                        Boolean(values.notifyBeforeDueDate) ||
                                                                        Boolean(values.changeNotifyBeforeDueDateValues)
                                                                    )
                                                                }
                                                                multiple
                                                                limitTags={8}
                                                                options={[...(resources.users || [])]}
                                                                label="Also notify users"
                                                                valueKey="id"
                                                                labelKey="name"
                                                                variant="standard"
                                                                renderOption={(option) => (
                                                                    <div className={classes.autocompleteOption}>
                                                                        <div className={classes.autocompleteOptionUserName}>
                                                                            <div>
                                                                                <strong>{option.name}</strong>
                                                                            </div>
                                                                            <small className={classes.adminFlag}>
                                                                                {option.isAdmin ? "admin" : ""}
                                                                            </small>
                                                                        </div>
                                                                        <small>{option.email}</small>
                                                                    </div>
                                                                )}
                                                                getOptionLabel={(option) => (option ? option.name : "")}
                                                            />
                                                        </>
                                                    )}
                                                </FormGroup>
                                            )}
                                        </FormControl>
                                    )}
                                </Grid>
                                <Grid item sm={12} md={5} className={classes.commentsPanel}>
                                    <FormControl fullWidth>
                                        <FormLabel component="legend">Comments</FormLabel>
                                        <FormGroup row className={classes.searchContainer}>
                                            <Input
                                                id="comment-to-search"
                                                value={commentToSearch}
                                                placeholder="Search..."
                                                fullWidth
                                                onChange={onSearchInputChange}
                                                onKeyDown={onSearchInputKeyDown}
                                                autoComplete="off"
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="send-message-button"
                                                            onClick={() => searchComment()}
                                                            color="primary"
                                                            title="Search"
                                                            onMouseDown={(e) => e.preventDefault()}
                                                        >
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                        </FormGroup>
                                        <FormGroup row>
                                            {isLoadingComments ? (
                                                <div className={classes.loaderContainer}>
                                                    <CircularProgress />
                                                </div>
                                            ) : (
                                                <div className={classes.commentsContainer}>
                                                    {comments.map((comment) => (
                                                        <Comment
                                                            key={`comment-${comment.id}`}
                                                            comment={comment}
                                                            resources={resources}
                                                            onEdit={onEditCommentHandler}
                                                            onDelete={onDeleteCommentHandler}
                                                            inEdition={commentToEdit && comment.id === commentToEdit.id}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        </FormGroup>
                                    </FormControl>
                                    <FormControl fullWidth className={classes.addCommentContainer}>
                                        <InputLabel htmlFor="comment-to-save">
                                            {commentInputMode === "add" ? "Leave a comment!" : "Edit comment!"}
                                        </InputLabel>
                                        <Input
                                            id="comment-to-save"
                                            value={commentToSave}
                                            onChange={(e) => setCommentToSave(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            multiline
                                            minRows={3}
                                            autoComplete="off"
                                            maxRows={3}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    {commentInputMode === "edit" && (
                                                        <IconButton
                                                            aria-label="cancel-message-button"
                                                            onClick={cancelEditComment}
                                                            color="secondary"
                                                            title="Cancel"
                                                            onMouseDown={(e) => e.preventDefault()}
                                                        >
                                                            <ClearIcon />
                                                        </IconButton>
                                                    )}
                                                    <IconButton
                                                        aria-label="send-message-button"
                                                        onClick={saveComment}
                                                        color="primary"
                                                        title="Send comment"
                                                        onMouseDown={(e) => e.preventDefault()}
                                                    >
                                                        <SendIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        )}
                    </FormikForm>
                )}
            </FormDialog>
            <ConfirmDialog {...statusChangeDisclaimerDialogProps} />
        </>
    );
}
